import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import style from './CatalogVideoModal.module.scss';
import Modal from 'react-bootstrap/Modal';
import useReactiveMessage from '../../hook/UseReactiveMessage';

const CatalogVideoModal = (props) => {

  const [open, setOpen] = useState(false);
  const [youTubeUrl, setYouTubeUrl] = useState();
  const {getMessage} = useReactiveMessage('CATALOG_VIDEO');

  const onModalClose = () => {
    setOpen(false);
  };

  let subscription;

  useEffect(() => {
    subscription = getMessage().subscribe(message => {
      if (message) {
        setYouTubeUrl(message.videoUrl);
        setOpen(true);
      }
    });

    let elements = document.getElementsByClassName('modal-youtube');
    elements.forEach(el => {
      el.addEventListener('click', (event) => {
        let source = event.currentTarget;
        if (source && source.dataset.youtube) {
          event.preventDefault();

          setYouTubeUrl(source.dataset.youtube);
          setOpen(true);
        }
      })
    })

  }, []);

  return (
    <Modal
      show={open}
      onHide={onModalClose}
      className="modal-youtube fade"
      dialogClassName={style.CatalogVideoModal}
      size={'lg'}
      centered
    >
      <Modal.Body className="p-0">
        <div className="embed-responsive embed-responsive-16by9">
          <iframe className="embed-responsive-item" frameBorder="0" allowFullScreen src={youTubeUrl}></iframe>
        </div>
      </Modal.Body>
    </Modal>
  )

};

export default CatalogVideoModal;
